import { useSuspenseQuery } from "@tanstack/react-query";
import { getPageSpeedMeasurement } from "../openapi/api-client.ts";
import { LoadMeasurementError } from "../errors/LoadMeasurementError.ts";
import { components } from "../openapi/generated-types.ts";

export type PageSpeedMeasurement =
  components["schemas"]["PageSpeedMeasurement"];

const POLL_INTERVAL_MS = 3000;

export const useLastMeasurement = (
  projectId: string,
  appInstallationId: string,
) =>
  useSuspenseQuery<PageSpeedMeasurement | null>({
    queryKey: ["pageSpeedMeasurement", { projectId, appInstallationId }],
    queryFn: async () => {
      const response = await getPageSpeedMeasurement({
        path: { projectId, appInstallationId },
      });

      if (response.data) {
        return response.data;
      }

      const status: number = response.response.status;
      if (status === 404) {
        return null;
      }

      throw new LoadMeasurementError(response.error.message);
    },
    refetchInterval: (query) =>
      query.state.data?.state === "pending" ? POLL_INTERVAL_MS : false,
  });
